import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaRegNoteSticky, FaFlask, FaGamepad, FaArrowRight } from 'react-icons/fa6';
import CallToAction from './CallToAction';

const CoursesSection = () => {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  
  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <>
      <section id="courses" className="py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-extrabold mb-4 relative gradient-text animate-float text-center">
              OUR <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 font-extrabold">COURSE PROGRAMS</span>
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-full animate-pulse mx-auto mb-4"></div>
            <p className="text-gray-600 max-w-2xl mx-auto mb-8">
              Discover our comprehensive range of STEM courses designed to inspire young minds and build the skills needed for future success.
            </p>
          </div>
          
          <motion.div 
            className="grid grid-cols-1 md:grid-cols-3 gap-8"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            {/* Certificate Courses Card */}
            <motion.div 
              className="flip-card h-[300px]"
              variants={itemVariants}
            >
              <div className="flip-card-inner">
                <div className="flip-card-front rounded-lg shadow-lg p-8 flex flex-col items-center justify-center bg-gradient-to-r from-[#2046b3] to-[#2d6af6]">
                  <FaRegNoteSticky className="text-5xl mb-4 text-white" />
                  <h3 className="text-2xl font-bold text-white">Certificate Courses</h3>
                </div>
                <div className="flip-card-back bg-gradient-to-r from-[#2046b3] to-[#2d6af6] text-white rounded-lg shadow-lg p-8 flex flex-col items-center justify-center">
                  <h3 className="text-2xl font-bold text-white mb-4">Certificate Courses</h3>
                  <Link to="/courses?category=all" className="btn bg-white text-blue-600 hover:bg-gray-100 transition-colors px-4 py-2 rounded-full font-medium">
                    Explore Courses
                  </Link>
                </div>
              </div>
            </motion.div>
            
            {/* Workshops Card */}
            <motion.div 
              className="flip-card h-[300px]"
              variants={itemVariants}
            >
              <div className="flip-card-inner">
                <div className="flip-card-front rounded-lg shadow-lg p-8 flex flex-col items-center justify-center bg-gradient-to-r from-[#2046b3] to-[#2d6af6]">
                  <FaFlask className="text-5xl mb-4 text-white" />
                  <h3 className="text-2xl font-bold text-white">Request Workshops with STEM Labs</h3>
                </div>
                <div className="flip-card-back bg-gradient-to-r from-[#2046b3] to-[#2d6af6] text-white rounded-lg shadow-lg p-8 flex flex-col items-center justify-center">
                  <h3 className="text-2xl font-bold text-white mb-4">Request Workshops with STEM Labs</h3>
                  <a 
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfR7AKakDahctDOzwRNX6yHbGfTRzjo9Q669a9EpKkQPsE4VQ/viewform" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn bg-white text-blue-600 hover:bg-gray-100 transition-colors px-4 py-2 rounded-full font-medium"
                  >
                    Request Here
                  </a>
                </div>
              </div>
            </motion.div>
            
            {/* Events & Competitions Card */}
            <motion.div 
              className="flip-card h-[300px]"
              variants={itemVariants}
            >
              <div className="flip-card-inner">
                <div className="flip-card-front rounded-lg shadow-lg p-8 flex flex-col items-center justify-center bg-gradient-to-r from-[#2046b3] to-[#2d6af6]">
                  <FaGamepad className="text-5xl mb-4 text-white" />
                  <h3 className="text-2xl font-bold text-white">Events & Competitions</h3>
                </div>
                <div className="flip-card-back bg-gradient-to-r from-[#2046b3] to-[#2d6af6] text-white rounded-lg shadow-lg p-8 flex flex-col items-center justify-center">
                  <h3 className="text-2xl font-bold text-white mb-4">Events & Competitions</h3>
                  <a 
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfP6lqznlJRU_mQCkkUrxNPNMNRVuJThBLgX93pKc3TXjawwQ/viewform" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn bg-white text-blue-600 hover:bg-gray-100 transition-colors px-4 py-2 rounded-full font-medium"
                  >
                    Register for the Competition
                  </a>
                </div>
              </div>
            </motion.div>
          </motion.div>
          
          {/* Explore All Courses button */}
          <div className="text-center mt-12">
            <Link 
              to="/courses" 
              className="inline-flex items-center justify-center bg-blue-600 text-white px-8 py-3 rounded-full hover:bg-blue-700 transition-colors shadow-md hover:shadow-lg"
            >
              Explore All Courses <FaArrowRight className="ml-2" />
            </Link>
            <p className="mt-4 text-gray-600 text-sm">
              View our full catalog of STEM education programs for all age groups and skill levels
            </p>
          </div>
        </div>
      </section>
      
      {/* Call to Action Section */}
      <CallToAction />
    </>
  );
};

export default CoursesSection; 